module.exports = require("./es-CO.js");